import "./key.css";
import { useEffect, useState, useRef } from "react";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import EditIcon from "@mui/icons-material/Edit";
import Button from "../../Custom/Button/Button";
import Question from "../Contacts/picture/question.png";
import Edit from "../Contacts/picture/edit.png";
import Close from "../Contacts/picture/close.png";
import Slanje from "../Contacts/picture/slanje.png";
import Dots from "../Contacts/picture/dots.png";
import Message from "../../picture/1.png";
import { Opacity } from "@mui/icons-material";
import Bell from "../../picture/whiteBell.png";
import axios from "axios";


const Key = ({ companyId }) => {
  const [listActive, setListActive] = useState([]);
  const [listNotActive, setListNotActive] = useState([]);
  const [selected, setSelected] = useState(null); // Track selected user ID
  const [showHistory, setShowHistory] = useState(null); // Track history toggle state
  const [editMode, setEditMode] = useState(null); // Track edit mode for selected user
  const [editingUserId, setEditingUserId] = useState(null); // Track the user being edited
  const [newPin, setNewPin] = useState(''); // Store the new PIN
  const [confirmPin, setConfirmPin] = useState(''); // Store the confirmed PIN
  const [loading, setLoading] = useState(true);
  const [highlightedUserId, setHighlightedUserId] = useState(null); // Tracks highlighted button

  const [slanjeClicked, setSlanjeClicked] = useState(false); // Tracks if "Slanje" has been clicked
  const [leftButtonsEnabled, setLeftButtonsEnabled] = useState(false); // Tracks if left buttons are enabled
  const [slanjeError, setSlanjeError] = useState(false)
  // Refs for the input fields
  const confirmPinRef = useRef(null);
  const [firstPinError, setFirstPinError] = useState(false); // Tracks error for the first input
  const [secondPinError, setSecondPinError] = useState(false);

  const [messageButtonActive, setMessageButtonActive] = useState(false);
  const [bellButtonActive, setBellButtonActive] = useState(false);
  const [dotsButtonActive, setDotsButtonActive] = useState(false);


  const [formFinalized, setFormFinalized] = useState(false);
  // const handleSlanjeClick = () => {
  //   if (!newPin || !confirmPin) return; // Prevent execution if fields are empty

  //   setSlanjeClicked(true); // Mark "Slanje" as clicked
  //   setLeftButtonsEnabled(true); // Enable left buttons

  //   // Perform save logic
  //   //handleSavePin(); // Save the pin but stay in the form
  // };

  const handleCloseClick = () => {
    // Reset the form to its initial state
    setFormFinalized(false);
    setNewPin("");
    setConfirmPin("");
    setSlanjeClicked(false);
  };
  const handleNewPinChange = (e) => {
    const value = e.target.value.slice(0, 4); // Limit to 4 characters
    setNewPin(value);

    // Clear errors and reset states when editing
    setFirstPinError(false);
    setSecondPinError(false);
    setSlanjeError(false);
    setSlanjeClicked(false); // Reset the green background
    setErrorMessage(""); // Clear error message when editing starts

    // Auto-focus on confirmPin when newPin reaches 4 characters
    if (value.length === 4) {
      confirmPinRef.current.focus();
    }

    // Validate if both fields are filled
    if (value.length === 4 && confirmPin.length === 4) {
      validatePins(value, confirmPin);
    }
  };

  const handleConfirmPinFocus = () => {
    if (newPin.length < 4) {
      setFirstPinError(true); // Highlight the first input as red
      document.getElementById("newPinInput").focus(); // Force focus back to the first input
    }
  };
  const handleConfirmPinChange = (e) => {
    const value = e.target.value.slice(0, 4); // Limit to 4 characters
    setConfirmPin(value);

    // Clear errors and reset states when editing
    setFirstPinError(false);
    setSecondPinError(false);
    setSlanjeError(false);
    setSlanjeClicked(false); // Reset the green background
    setErrorMessage(""); // Clear error message when editing starts

    // Validate if both fields are filled
    if (value.length === 4 && newPin.length === 4) {
      validatePins(newPin, value);
    }
  };
  const validatePins = (pin1, pin2) => {
    if (pin1 === pin2) {
      if (pin1 === currentPin) {
        // If the new PIN matches the current PIN
        setSlanjeClicked(false); // Prevent button from turning green
        setErrorMessage("PIN koji ste uneli je isti kao trenutni."); // Display error message
      } else {
        // Check if the new PIN was used in the past
        const currentUser = listActive.concat(listNotActive).find(
          (user) => user.id === editingUserId
        );

        if (currentUser?.history) {
          const pinHistory = currentUser.history.map((entry) => entry.code);
          if (pinHistory.includes(pin1) && pin1 !== currentPin) {
            setErrorMessage("PIN koji ste uneli je ranije bio u upotrebi."); // Display reuse warning
          } else {
            setErrorMessage(""); // Clear any previous messages
          }
        }

        setSlanjeClicked(true); // Mark the button as valid (green)
      }
      setFirstPinError(false); // Clear errors
      setSecondPinError(false);
    } else {
      setSlanjeClicked(false); // Reset the "Slanje" button state
      setFirstPinError(true); // Highlight both inputs as red
      setSecondPinError(true);
      setErrorMessage("PIN-ovi se ne poklapaju."); // Display mismatch error
    }
  };


  const handleFirstInputBlur = () => {
    if (newPin.length < 4) {
      setFirstPinError(true); // Highlight error for the first input
      setTimeout(() => {
        document.getElementById("newPinInput").focus(); // Return focus to the first input
      }, 0);
    }
  };

  const handleSecondInputFocus = () => {
    if (newPin.length < 4) {
      setFirstPinError(true); // Highlight error for the first input
      document.getElementById("newPinInput").focus(); // Force focus back to the first input
    }
  };
  
  const [currentPin, setCurrentPin] = useState("");

  useEffect(() => {
    if (editingUserId) {
      const currentUser = listActive
        .concat(listNotActive)
        .find((user) => user.id === editingUserId);

      setCurrentPin(currentUser?.code || ""); // Set the current PIN or default to an empty string
    } else {
      setCurrentPin(""); // Reset if no user is being edited
    }
  }, [editingUserId, listActive, listNotActive]);

  const [errorMessage, setErrorMessage] = useState(""); // Store error messages


  const handleSlanjeClick = () => {
    if (!newPin || !confirmPin) {
      setFirstPinError(!newPin);
      setSecondPinError(!confirmPin);
      setSlanjeError(true); // Temporarily turn the button red
      setErrorMessage("Morate uneti oba PIN-a."); // Display error message
      setTimeout(() => setSlanjeError(false), 1000); // Reset button color after 1 second
      return;
    }

    if (newPin !== confirmPin) {
      setFirstPinError(true);
      setSecondPinError(true);
      setSlanjeError(true); // Temporarily turn the button red
      setErrorMessage("PIN-ovi se ne poklapaju."); // Display error message
      setTimeout(() => setSlanjeError(false), 1000); // Reset button color after 1 second
      return;
    }

    if (newPin === currentPin) {
      setFirstPinError(true);
      setSecondPinError(true);
      setSlanjeError(true); // Temporarily turn the button red
      setErrorMessage("PIN koji ste uneli je isti kao trenutni."); // Display error message
      setTimeout(() => setSlanjeError(false), 1000); // Reset button color after 1 second
      return;
    }

    // If all validations pass
    setSlanjeClicked(true); // Mark button as green
    setSlanjeError(false); // Reset error state
    setFormFinalized(true); // Finalize the form
    setErrorMessage(""); // Clear error message
  };









  const fetchUsers = async () => {
    console.log("fetchUsers function called");

    try {
      const response = await axios.get(
        `https://data.nadzor.app/api/admin_panel/key/read.php?company_id=1` // Hardcoded company_id
      );

      console.log("API Response:", response.data);

      if (response.data.status === 200) {
        const users = response.data.users;
        const activeUsers = users.filter((user) => user.active);
        const inactiveUsers = users.filter((user) => !user.active);

        setListActive(activeUsers);
        setListNotActive(inactiveUsers);
      } else {
        console.error("Error fetching users:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  };

  // const handleNewPinChange = (e) => {
  //   const value = e.target.value.slice(0, 4); // Limit to 4 characters
  //   setNewPin(value);

  //   if (value.length === 4) {
  //     confirmPinRef.current.focus(); // Move focus to the next field
  //   }
  // };

  // const handleConfirmPinChange = (e) => {
  //   const value = e.target.value.slice(0, 4); // Limit to 4 characters
  //   setConfirmPin(value);
  // };

  useEffect(() => {
    console.log("Fetching users for company_id=1"); // Debug log
    fetchUsers();
  }, []); // Empty dependency array to run on component mount only

  const toggleHistory = (id) => {
    setShowHistory((prev) => (prev === id ? null : id)); // Toggle history for the selected user
  };

  const markAsRead = (user) => {
    if (user.updatedRecently) {
      // Update the user in the corresponding list
      if (user.active) {
        setListActive((prev) =>
          prev.map((item) =>
            item.id === user.id ? { ...item, updatedRecently: false } : item
          )
        );
      } else {
        setListNotActive((prev) =>
          prev.map((item) =>
            item.id === user.id ? { ...item, updatedRecently: false } : item
          )
        );
      }
      setSelected(user.id); // Open the collapse for this user
      setShowHistory(null); // Ensure the last change is displayed
    }
  };

  const toggleActiveState = (user) => {
    if (user.active) {
      setListActive((prev) => prev.filter((item) => item.id !== user.id));
      setListNotActive((prev) => [
        ...prev,
        { ...user, active: false },
      ]);
    } else {
      setListNotActive((prev) => prev.filter((item) => item.id !== user.id));
      setListActive((prev) => [
        ...prev,
        { ...user, active: true },
      ]);
    }
  };

  const handleEditButtonClick = (user) => {
    if (highlightedUserId === user.id) {
      // If green edit is clicked again, open edit form
      setShowEditForm(true);
      setEditingUserId(user.id);
    } else {
      // Turn the button green and show last change
      setHighlightedUserId(user.id); // Highlight the button
      setSelected(user.id); // Show the last change
      setShowEditForm(false); // Ensure form is closed initially
    }
  };

  const handleQuestionClick = (user) => {
    // Reset the question mark and collapse the history
    setListActive((prev) =>
      prev.map((item) =>
        item.id === user.id ? { ...item, updatedRecently: false } : item
      )
    );
    setListNotActive((prev) =>
      prev.map((item) =>
        item.id === user.id ? { ...item, updatedRecently: false } : item
      )
    );

    // Reset the highlighted and selected states
    setHighlightedUserId(null); // Ensure it does not turn green
    setSelected(null); // Collapse the history
  };

  const handleQuestionMarkClick = (user) => {
    if (selected === user.id) {
      // If already active, reset to inactive state
      setSelected(null); // Hide last change
      setHighlightedUserId(null); // Ensure edit is not green
      setListActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
      setListNotActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
    } else {
      // Activate question mark and show the last change
      setSelected(user.id);
      setHighlightedUserId(null); // Ensure it doesn't turn green
    }
  };

  const toggleNameClick = (user) => {
    if (selected === user.id) {
      // Deactivate both buttons and hide the last change
      setSelected(null);
      setHighlightedUserId(null); // Reset the edit/question mark button
      setListActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
      setListNotActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
    } else {
      // Activate the name button, show the last change
      setSelected(user.id);
      setHighlightedUserId(null); // Ensure the question mark/edit button remains inactive
    }
  };

  const handleToggleLastChange = (user) => {
    if (selected === user.id) {
      // Close the last change and reset buttons
      setSelected(null);
      setHighlightedUserId(null); // Reset edit button
      setListActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
      setListNotActive((prev) =>
        prev.map((item) =>
          item.id === user.id ? { ...item, updatedRecently: false } : item
        )
      );
    } else {
      // Open the last change and activate buttons
      setSelected(user.id);
      setHighlightedUserId(user.id); // Highlight the edit button
    }
  };

  // Update the function handling key updates
  const handleSavePin = async () => {
    if (newPin !== confirmPin) {
      alert("Pins do not match!");
      return;
    }

    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/key/update.php",
        {
          userId: editingUserId,
          pin: newPin,
          company_id: 1, // Replace with dynamic companyId if available
          updated_by: 1, // Replace with the actual admin/moderator ID
        }
      );

      if (response.data.status === 200) {
        alert("PIN updated successfully!");

        // Update the local state for the updated user
        setListActive((prev) =>
          prev.map((user) =>
            user.id === editingUserId
              ? { ...user, updatedRecently: true } // Show question mark
              : user
          )
        );
        setListNotActive((prev) =>
          prev.map((user) =>
            user.id === editingUserId
              ? { ...user, updatedRecently: true } // Show question mark
              : user
          )
        );

        // Reset states
        setEditingUserId(null);
        setHighlightedUserId(null);
        setNewPin(""); // Clear PIN inputs
        setConfirmPin(""); // Clear PIN inputs
        setSelected(null);
      } else {
        alert("Failed to update PIN: " + response.data.message);
      }
    } catch (error) {
      console.error("Error updating PIN:", error.message);
      alert("An error occurred while updating the PIN.");
    }
  };

  const closeCollapsedText = () => {
    setSelected(null); // Collapse history
    setHighlightedUserId(null); // Reset highlighted button
    setEditingUserId(null); // Ensure no form is open
  };

  const toggleSelected = (id) => {
    setSelected((prev) => (prev === id ? null : id)); // Toggle the last change
    setHighlightedUserId(null); // Reset the edit button to black
  };

  // // Function to handle cancel action
  // const cancelEdit = () => {
  //   setEditingUserId(null); // Close the edit form
  //   setNewPin(''); // Reset PIN input
  //   setConfirmPin(''); // Reset confirmation input
  //   setSlanjeClicked(false); // Mark "Slanje" as clicked
  //   setLeftButtonsEnabled(false); // Enable left buttons
  //   setSelected(null); // Collapse history
  //   setHighlightedUserId(null); // Reset highlighted button
  // };
  const cancelEdit = () => {
    setEditingUserId(null); // Close the edit form
    setNewPin(""); // Reset PIN input
    setConfirmPin(""); // Reset confirmation input
    setSlanjeClicked(false); // Reset Slanje state
    setLeftButtonsEnabled(false); // Reset button states
    setSelected(null); // Collapse history
    setHighlightedUserId(null); // Reset highlighted button
    setSlanjeError(false); // Reset error state
  };

  const handleEditOrQuestionClick = (user) => {
    if (user.updatedRecently) {
      // Handle Question Mark click
      setListActive((prev) =>
        prev.map((item) =>
          item.id === user.id
            ? { ...item, updatedRecently: false } // Mark as not recently updated
            : item
        )
      );
      setListNotActive((prev) =>
        prev.map((item) =>
          item.id === user.id
            ? { ...item, updatedRecently: false } // Mark as not recently updated
            : item
        )
      );

      // Turn the button green
      setHighlightedUserId(user.id);

      // Collapse the history immediately
      toggleSelected(user.id);
    } else {
      // Handle Edit button click (reuse existing logic)
      handleEditButtonClick(user);
    }
  };

  const [showEditForm, setShowEditForm] = useState(false);
  const handleShare = () => {
    const user = listActive
      .concat(listNotActive)
      .find((user) => user.id === editingUserId);

    if (!user) {
      alert("User not found.");
      return;
    }

    const shareData = {
      title: "Promena pristupnog koda",
      text: `Za korisnika sa adresom ${user.name} je promenjen pristupni KOD.\nNovi KOD je ${newPin}.`,
    };

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => {
          handleSavePin(); // Save the PIN after sending the notification
          cancelEdit(); // Close the edit form after sending the notification
        })
        .catch((error) => console.log("Error sharing:", error));
    } else {
      alert("Sharing is not supported on this browser.");
    }
  };
  const formatDateTime = (date, time) => {
    if (!date || !time) return "N/A";

    const [year, month, day] = date.split("-"); // Split date string (YYYY-MM-DD)
    return `${day}.${month}.${year} ${time}`; // Format to DD.MM.YYYY HH:MM
  };

  const toggleUserActiveState = async (user) => {
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/key/toggleActive.php",
        {
          userId: user.id,
          companyId: 1, // Replace with dynamic companyId if available
          active: !user.active, // Toggle the current active state
        }
      );

      if (response.data.status === 200) {
        alert(response.data.message);

        // Update the local state to reflect the changes
        if (user.active) {
          setListActive((prev) => prev.filter((u) => u.id !== user.id)); // Remove from active list
          setListNotActive((prev) => [
            ...prev,
            { ...user, active: false, lastInactiveDate: new Date() }, // Add to inactive list
          ]);
        } else {
          setListNotActive((prev) => prev.filter((u) => u.id !== user.id)); // Remove from inactive list
          setListActive((prev) => [
            ...prev,
            { ...user, active: true, lastInactiveDate: null }, // Add to active list
          ]);
        }
      } else {
        alert("Failed to update user status: " + response.data.message);
      }
    } catch (error) {
      console.error("Error toggling user active state:", error.message);
      alert("An error occurred while toggling user active state.");
    }
  };

 
  const handleBellClick = async () => {
    const user = listActive
      .concat(listNotActive)
      .find((user) => user.id === editingUserId);

    if (!user) {
      alert("User not found.");
      return;
    }

    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/user_notification_list/create.php",
        {
          user_id: user.id,
          company_name: "Top Auto",
          new_code: newPin
        }
      );

      if (response.data.status === 200) {
        alert("Notification sent successfully!");
        handleSavePin(); // Save the PIN after sending the notification
        cancelEdit(); // Close the edit form after sending the notification
      } else {
        alert("Failed to send notification: " + response.data.message);
      }
    } catch (error) {
      console.error("Error sending notification:", error.message);
      alert("An error occurred while sending the notification.");
    }
  };
 
  const fetchChatRooms = async (editingUserId) => {
    const companyExternalId = 108; // Hardcoded company external ID
    const apiKeyCompany = "0814664dc8a2ac2bd3f1c469b2d77541db98ce0118f23139a68b366010bc86ed"; // Replace with the actual key
  
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/admin_panel/chat/getChatRoomsForExternalUser.php",
        {
          external_user_id: companyExternalId,
          api_key_company: apiKeyCompany,
        }
      );
  
      if (response.data.status === 200) {
        const chatRooms = response.data.data;
  
        // Check if the user whose PIN is being edited is in the chat rooms
        const currentUserChatRoom = chatRooms.find(
          (room) => String(editingUserId) === room.id
        );
  
        if (currentUserChatRoom) {
          console.log("User is already in a chat room:", currentUserChatRoom);
          // Logic if the user is already in a chat room
          return currentUserChatRoom; // Return the existing chat room
        } else {
          console.log(
            "User is not in any chat room. You might need to create a new chat room."
          );
          // Logic for creating a new chat room can be added here
          return null;
        }
      } else {
        console.error("Error fetching chat rooms:", response.data.message);
        alert("Unable to fetch chat rooms.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching chat rooms:", error.message);
      alert("An error occurred while fetching chat rooms.");
      return null;
    }
  };
  const handleMessageButtonClick = async () => {
    const senderName = "Top-Auto"; // Replace with the sender name or email
    const messageText = "Hello, this is a test message!"; // Replace with your message text
    const apiKey = "0814664dc8a2ac2bd3f1c469b2d77541db98ce0118f23139a68b366010bc86ed"; // Replace with your API key
    const timestamp = new Date().toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }); // Format date as DD.MM.YYYY HH:mm
  
    try {
      // Step 1: Check if chat room exists or create one
      const profile1Id = editingUserId; // Replace with the current user ID being edited
      const profile2Id = 108; // Replace with the hardcoded company profile ID
  
      const checkOrCreateResponse = await axios.post(
        "https://data.nadzor.app/api/admin_panel/chat/createRoom.php", // Endpoint for creating/finding chat rooms
        {
          profile1_id: profile1Id,
          profile2_id: profile2Id,
        }
      );
  
      if (checkOrCreateResponse.data.status === 200 || checkOrCreateResponse.data.status === 201) {
        console.log("Chat room exists or created successfully:", checkOrCreateResponse.data);
        const chatRoomId = checkOrCreateResponse.data.chat_room.cr_id;
  
        // Step 2: Send a message to the chat room
        const sendMessageResponse = await axios.post(
          "https://data.nadzor.app/api/admin_panel/chat/sendMessage2.php", // Endpoint for sending messages
          {
            sender: "CompanyTest1",
            text: messageText,
            date: "23.01.2025 17:03",
            api_key: apiKey,
            chat_room_id: chatRoomId,
          }
        );
  
        if (sendMessageResponse.data.status === 200) {
          console.log("Message sent successfully:", sendMessageResponse.data);
        } else {
          console.error("Failed to send message:", sendMessageResponse.data.message);
        }
      } else {
        console.error("Failed to create or find chat room:", checkOrCreateResponse.data.message);
      }
    } catch (error) {
      console.error("Error handling message button click:", error.message);
    }
  };
  
  
  
  
  
  return (
    <div className="key-wrapper">
      {/* Show the list if no edit form is open */}
      {editingUserId === null && (
        <>
          {/* Active Users */}
          {listActive.map((user) => (
            <div key={user.id} className="key-item">
              <div className="key-header">
                <button
                  id="name"
                  className={selected === user.id ? "dos-btn-active" : ""}
                  onClick={() => toggleNameClick(user)}
                >
                  {user.name}
                </button>

                <button
                  id="edit"
                  className={
                    user.updatedRecently
                      ? selected === user.id
                        ? "dos-btn-active" // Active state for question mark
                        : "" // Inactive question mark
                      : highlightedUserId === user.id
                        ? "edit-btn-green" // Green for edit button
                        : ""
                  }
                  style={{
                    color: user.updatedRecently ? "#ff3519ff" : "inherit", // Red for the question mark
                    cursor: "pointer",
                    fontWeight: user.updatedRecently ? "bold" : "normal",
                  }}
                  onClick={() =>
                    user.updatedRecently
                      ? handleQuestionMarkClick(user) // Handle question mark behavior
                      : handleEditButtonClick(user) // Handle edit button behavior
                  }
                >
                  {user.updatedRecently ? "?" : <EditIcon />}
                </button>

                <button
                  id="toggle-active"
                  onClick={() => toggleUserActiveState(user)}
                >
                  <LockIcon />
                </button>
              </div>

              {selected === user.id && (
                <div className="collapsed-text">
                  <div className="collapsed-text-1">
                    <button onClick={() => toggleHistory(user.id)}>
                      <img src={Question} alt="History" />
                    </button>
                    <button onClick={closeCollapsedText}>
                      <img src={Close} alt="Close" />
                    </button>
                  </div>

                  <div>
                    <div className="collapsed-text-2">
                      <span>
                        {formatDateTime(user.history[0]?.date, user.history[0]?.time)}
                      </span>
                      <span>
                        <strong>
                          {user.history[0]?.code || "N/A"}
                        </strong>
                      </span>
                    </div>
                    <div className="collapsed-text-3">
                      <span>{user.history[0]?.updated_by || "Unknown"}</span>
                    </div>
                    <hr />
                  </div>

                  {showHistory === user.id &&
                    user.history.slice(1).map((entry, index) => ( // Use slice(1) to skip the first entry
                      <div key={index}>
                        <div className="collapsed-text-2">
                          <span>{formatDateTime(entry.date, entry.time)}</span>
                          <span>
                            <strong>
                              {entry.code}
                            </strong>
                          </span>
                        </div>
                        <div className="collapsed-text-3">
                          <span>{entry.updated_by}</span>
                        </div>
                        <hr />
                      </div>
                    ))}

                </div>
              )}

            </div>
          ))}

          <div style={{ margin: "20px 0" }}>
            <hr />
          </div>

          {/* Inactive Users */}
          {listNotActive.map((user) => (
            <div key={user.id} className="key-item">
              <div className="key-header">
                <button
                  id="name"
                  className={selected === user.id ? "dos-btn-active" : ""}
                  onClick={() => toggleSelected(user.id)}
                  style={{}}
                >
                  <strong>{user.name}</strong>
                </button>

                <button
                  id="edit"
                  style={{ opacity: "0.3" }}
                >
                  <img src={Edit} alt="Edit" />
                </button>

                <button
                  className="dos-btn-active"
                  id="toggle-active"
                  style={{ color: "#ff3519ff" }}
                  onClick={() => toggleUserActiveState(user)}
                >
                  <LockOpenIcon />
                </button>
              </div>

              {selected === user.id && (
                <div className="collapsed-text">
                  <div className="collapsed-text-1">
                    <button onClick={() => toggleHistory(user.id)}>
                      <img src={Question} alt="History" />
                    </button>
                    <button onClick={closeCollapsedText}>
                      <img src={Close} alt="Close" />
                    </button>
                  </div>

                  <div>
                    <div className="collapsed-text-2">
                      <span>
                        {formatDateTime(user.history[0]?.date, user.history[0]?.time)}
                      </span>
                      <span>{user.history[user.history.length - 1]?.code || "N/A"}</span>
                    </div>
                    <div className="collapsed-text-3">
                      <span>{user.history[user.history.length - 1]?.updated_by || "Unknown"}</span>
                    </div>
                  </div>

                  {showHistory === user.id &&
                    user.history
                      .slice(0, -1)
                      .map((entry, index) => (
                        <div key={index}>
                          <div className="collapsed-text-2">
                            <span>{formatDateTime(entry.date, entry.time)}</span>
                            <span>{entry.code}</span>
                          </div>
                          <div className="collapsed-text-3">
                            <span>{entry.updated_by}</span>
                          </div>
                        </div>
                      ))}
                  <hr />
                </div>
              )}
            </div>
          ))}
        </>
      )}

      {/* Show edit form if a user is being edited */}
      {showEditForm && editingUserId !== null && (
        <div className="edit-form-wrapper">
          <div className="edit-form">
            <h2>
              {!formFinalized ? <>
                Trenutni ključ:{" "}
                {listActive
                  .concat(listNotActive)
                  .find((user) => user.id === editingUserId)?.code || "User"}
              </> : <>
                Novi ključ: {newPin}
              </>}

            </h2>

            {formFinalized ? <>
              <div className="obavestenje">
                {`Za korisnika sa adresom miljana.stankovic@komot.rs će biti promenjen pristupni kod.`}
              </div>
            </> : <>

            </>}
            <div className="edit-form-parts">
              <div className="edit-left-part">
                {!formFinalized && (
                  <div className="edit-left-inputs">
                    <input
                      id="newPinInput"
                      type="number"
                      value={newPin}
                      onChange={handleNewPinChange}
                      placeholder="Enter new PIN"
                      maxLength="4"
                      style={{
                        color: firstPinError ? "red" : "inherit", // Highlight if error
                      }}
                    />
                    <input
                      type="number"
                      ref={confirmPinRef}
                      value={confirmPin}
                      onChange={handleConfirmPinChange}
                      placeholder="Confirm new PIN"
                      maxLength="4"
                      style={{
                        color: secondPinError ? "red" : "inherit", // Highlight if error
                      }}
                    />
                  </div>
                )}
                <div className="left-buttons">
                  <button
                    style={{
                      opacity: formFinalized ? "1" : "0.4", // Enable when finalized
                      pointerEvents: formFinalized ? "auto" : "none",
                    }}
                    onClick={handleMessageButtonClick}
                  >
                    <img src={Message} alt="Message" />
                  </button>
                  <button
                    style={{
                      opacity: formFinalized ? "1" : "0.4", // Enable when finalized
                      pointerEvents: formFinalized ? "auto" : "none",
                    }}
                    onClick={handleBellClick}
                  >
                    <img src={Bell} alt="Bell" />
                  </button>
                  <button
                    style={{
                      opacity: formFinalized ? "1" : "0.4", // Enable when finalized
                      pointerEvents: formFinalized ? "auto" : "none",
                    }}
                    onClick={handleShare}
                  >
                    <img src={Dots} alt="Dots" />
                  </button>
                </div>
              </div>
              <div className="edit-right-part">
                {!formFinalized && (
                  <button onClick={cancelEdit}>
                    <img src={Close} alt="Close" />
                  </button>
                )}
                <button
                  onClick={formFinalized ? handleCloseClick : handleSlanjeClick}
                  style={{
                    backgroundColor: formFinalized
                      ? "" // Default
                      : slanjeError
                        ? "red" // Temporarily red if error
                        : slanjeClicked
                          ? "#00b055" // Green when valid
                          : "", // Default background
                    width: formFinalized
                      ? "50px" : "62.5px",
                    height: formFinalized
                      ? "50px" : "62.5px",
                    color: formFinalized || slanjeClicked || slanjeError ? "white" : "",
                  }}
                  disabled={!formFinalized && (!newPin || !confirmPin)} // Disable if incomplete
                >
                  <img src={formFinalized ? Close : Slanje} alt="Slanje or Close" />
                </button>


              </div>
            </div>

            {/* Message under the form */}
            {formFinalized ? (
              <>
                <div className="obavestenje">
                  {`Odaberite jednu od opcija za obaveštavanje korisnika o promeni PIN-a. Ukoliko ne obavestite korisnika smatraće se da odustajete od kreiranja/izmene PIN-a.`}
                </div>
              </>
            ) : (
              <>
                {errorMessage && (
                  <p style={{ marginTop: "10px" }}>
                    {errorMessage}
                  </p>
                )}

              </>
            )}

          </div>
        </div>

      )}

    </div>
  );
};

export default Key;
